module.exports = {
	"pl": {
		"conversation": {
			"widget": {
				"title": "Porozmawiaj z nami na czacie",
				"subtitle": ""
			}
		}
	}
};